import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * POST `/mom/work-order/{workOrderId}/stock-issue/{stockIssueId}/submit`
 * body 通常僅 `updatedAt`。
 *
 * @param {string} workOrderId
 * @param {string} stockIssueId
 * @param {object} [payload]
 */
export async function submitWorkOrderStockIssue(
  workOrderId,
  stockIssueId,
  payload = {},
) {
  const { data: raw } = await request.post(
    `/mom/work-order/${workOrderId}/stock-issue/${stockIssueId}/submit`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
